import type { Ref } from 'vue';

import { onClickOutside } from '@vueuse/core';

interface UseShareMenuOptions {
	shareContentRef: Ref<HTMLElement | null>;
	shareContentButton: Ref<HTMLElement | null>;
}

interface ShareOptions {
	title: string;
	url: string;
}

interface UseShareMenuReturn {
	isShareContentVisible: Ref<boolean>;
	toggleShareContent: () => void;
	share: (options: ShareOptions) => void;
}

export function useShareMenu(options: UseShareMenuOptions): UseShareMenuReturn {
	const isShareContentVisible = ref(false);

	function toggleShareContent() {
		isShareContentVisible.value = !isShareContentVisible.value;
	}

	function share(options: { title: string; url: string }) {
		if (navigator?.share) {
			navigator.share(options);
		} else {
			toggleShareContent();
		}
	}

	onClickOutside(
		options.shareContentRef,
		() => (isShareContentVisible.value = false),
		{
			ignore: [options.shareContentButton]
		}
	);

	return {
		isShareContentVisible,
		toggleShareContent,
		share
	};
}
